export var MessageType;
(function (MessageType) {
    MessageType["Text"] = "TEXT";
    MessageType["Email"] = "EMAIL";
    MessageType["PartnerNote"] = "PARTNER_NOTE";
    MessageType["ZicassoNote"] = "ZICASSO_NOTE";
    MessageType["PhoneCall"] = "PHONE_CALL";
    MessageType["PhoneCallUnanswered"] = "PHONE_CALL_UNANSWERED";
    MessageType["SMS"] = "SMS";
    MessageType["Hidden"] = "HIDDEN";
    MessageType["DocumentCreated"] = "DOCUMENT_CREATED";
    MessageType["DocumentUpdated"] = "DOCUMENT_UPDATED";
    MessageType["SalesRecordingCreated"] = "SALES_RECORDING_CREATED";
    MessageType["SalesRecordingUpdated"] = "SALES_RECORDING_UPDATED";
    MessageType["SalesRecordingCanceled"] = "SALES_RECORDING_CANCELED";
    MessageType["SampleItineraryCreated"] = "SAMPLE_ITINERARY_CREATED";
    MessageType["SampleItineraryUpdated"] = "SAMPLE_ITINERARY_UPDATED";
    MessageType["TripMatchCanceled"] = "TRIP_MATCH_CANCELED";
    MessageType["TripMatchDeclined"] = "TRIP_MATCH_DECLINED";
    MessageType["TripMatchPostponed"] = "TRIP_MATCH_POSTPONED";
    MessageType["TripMatchInactive"] = "TRIP_MATCH_INACTIVE";
    MessageType["TripMatchReopened"] = "TRIP_MATCH_REOPENED";
    MessageType["TripMatchReviewRequest"] = "TRIP_MATCH_REVIEW_REQUEST";
    MessageType["TripRequestPostponed"] = "TRIP_REQUEST_POSTPONED";
    MessageType["TripRequestCanceled"] = "TRIP_REQUEST_CANCELED";
    MessageType["TripRequestReferred"] = "TRIP_REQUEST_REFERRED";
    MessageType["TripRequestReopened"] = "TRIP_REQUEST_REOPENED";
    MessageType["MessageTravelerJoinedConversation"] = "TRAVELER_JOINED_CONVERSATION";
    MessageType["MessageAgentJoinedConversation"] = "AGENT_JOINED_CONVERSATION";
    MessageType["MessageTeamMemberJoinedConversation"] = "TEAM_MEMBER_JOINED_CONVERSATION";
    MessageType["MessageTravelerInvited"] = "TRAVELER_INVITED";
})(MessageType || (MessageType = {}));
